"use client";

import { Typography } from "@/components/ui/typography";
import type { IndustriesSolutionsProps } from "./types";
import { industriesSolutionsData } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { SolutionsCardsCarousel } from "@/components/screen/global-components/solutions";

const IndustriesSolutions = ({ className }: IndustriesSolutionsProps) => {
  const { title, description, cards } = industriesSolutionsData;

  return (
    <section
      className={cn("section overflow-hidden bg-white lg:bg-background-secondary", className)}
    >
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col justify-center gap-4">
          <Typography variant="heading4" className="md:text-center">
            <h2>{title}</h2>
          </Typography>
          <div className="flex md:justify-center text-gray-600 max-w-[780px] mx-auto">
            <Typography
              variant="subHeadingSm"
              className="md:text-center"
              asChild
            >
              <p>{description}</p>
            </Typography>
          </div>
        </div>
        <SolutionsCardsCarousel cards={cards} className="mt-6 md:mt-12" />
      </div>
    </section>
  );
};

export default memo(IndustriesSolutions);
